import { EXTERNAL_LINKS } from '@psyomics/ui-common';
import { cn } from '@shadcn/lib/utils';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface IPageLinkProps {
  readonly text: string;
  readonly to: string;
  readonly className?: string;
}

const isExternalUrl = (url: string): boolean => {
  return (Object.values(EXTERNAL_LINKS) as readonly string[]).includes(url);
};

export function PageLink({ className, text, to }: IPageLinkProps) {
  const linkClassName = cn(
    'self-stretch py-5 border-b border-gray-500 flex justify-between items-center cursor-pointer hover:bg-gray-50 no-underline',
    className
  );

  const content = (
    <>
      <div className="text-slate-800 text-lg font-semibold">{text}</div>
      <ArrowRight className="w-6 h-6" />
    </>
  );

  if (isExternalUrl(to)) {
    return (
      <a className={linkClassName} href={to} rel="noopener noreferrer" target="_blank">
        {content}
      </a>
    );
  }

  return (
    <Link className={linkClassName} to={to}>
      {content}
    </Link>
  );
}
